import React from "react";
import PropTypes from "prop-types";
import cn from "../../../utilities/classNames";
import { format } from "../../../utilities/time";
import { evaluate } from "../../../utilities/props";
import TimeLineGreen from "./TimeLineGreen";

const ProgressGreen = ({ className, time, duration, onSkip }) => {
  time = evaluate(time);
  duration = evaluate(duration);

  return (
    <div className={cn("Progress", {}, className)}>
      <TimeLineGreen
        className="Progress__track white"
        onSkip={onSkip}
        time={time}
        duration={duration}
      />
      <div className="alt-right-controls">
        <ul className="controls">
          <li className="alt-stream-length white">{format(duration - time)}</li>
        </ul>
      </div>
    </div>
  );
};

ProgressGreen.propTypes = {
  className: PropTypes.string,
  // time: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  // duration: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  onSkip: PropTypes.func,
};

export default ProgressGreen;
